import { AlertTriangle, Ban, ChefHat, Repeat } from 'lucide-react';
import { conflictText } from '../utils/mealConflicts';
import { getSwapConflictEntries, getSwapWarningBubble } from '../utils/swapStatus';

function toneClass(tone) {
  if (tone === 'danger') return 'bg-red-500 text-white';
  if (tone === 'info') return 'bg-slate-600 text-white';
  return 'bg-amber-500 text-white';
}

function icon(bubble) {
  if (bubble.tone === 'danger' || bubble.key === 'dont_suggest') return <Ban size={11} />;
  if (bubble.key === 'cookware') return <ChefHat size={11} />;
  if (bubble.tone === 'info') return <Repeat size={11} />;
  return <AlertTriangle size={11} />;
}

export default function MealConflictPill({ meal, testId }) {
  var bubble = getSwapWarningBubble(meal);
  if (!bubble) return null;
  var entries = getSwapConflictEntries(meal);
  return (
    <div className={'absolute bottom-2 left-2 w-fit max-w-[calc(100%-1rem)] px-2 py-1 rounded-lg text-[11px] font-medium flex items-center gap-1 ' + toneClass(bubble.tone)}
      data-testid={testId} title={entries.map(conflictText).join(' · ')}>
      {icon(bubble)}<span className="truncate">{bubble.label}</span>
    </div>
  );
}
